import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const BANDERAS = [
  { codigo:'co', pais:'Colombia' },
  { codigo:'ca', pais:'Canada' },
  { codigo:'us', pais:'United States' },
  { codigo:'br', pais:'Brazil' },
  { codigo:'jp', pais:'Japan' },
  { codigo:'cn', pais:'China' },
  { codigo:'gb', pais:'United Kingdom' },
  { codigo:'fr', pais:'France' },
  { codigo:'pt', pais:'Portugal' },
]

function Bandera({ codigo, pais, size = 20 }) {
  return (
    <img
      src={'https://flagcdn.com/' + (size <= 20 ? 24 : 48) + 'x' + (size <= 20 ? 18 : 36) + '/' + codigo + '.png'}
      alt={pais}
      title={pais}
      style={{ width: size, height: Math.round(size * 0.75), borderRadius: 3, objectFit:'cover', boxShadow:'0 1px 3px rgba(0,0,0,0.4)', flexShrink:0 }}
    />
  )
}

const PROFESORES = [
  {
    nombre: 'Ivan Andrés Correa Sisa',
    titulo: 'Licenciado en Lengua Castellana, Inglés y Francés',
    especialidad: 'Spanish Conversation & Grammar',
    emoji: '👨‍🏫',
    descripcion: 'Ivan is a certified language teacher with expertise in Spanish, English and French. He specializes in conversational Spanish and helps students master Colombian expressions and culture through dynamic, engaging classes.',
    niveles: ['A1', 'A2', 'B1', 'B2'],
    color: '#1B3A8C'
  },
  {
    nombre: 'Jorge Andrés Solano Vargas',
    titulo: 'Licenciado en Humanidades e Inglés',
    especialidad: 'Spanish for Professionals',
    emoji: '👨‍💼',
    descripcion: 'Jorge brings a humanistic approach to language teaching, connecting Spanish learning with culture, history and real-life communication. He specializes in helping intermediate and advanced students reach fluency.',
    niveles: ['B1', 'B2', 'C1'],
    color: '#059669'
  }
]

/* Hook simple para detectar si estamos en tamaño movil */
function useEsMovil() {
  const [esMovil, setEsMovil] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= 820 : false
  )
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 820px)')
    const handler = e => setEsMovil(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])
  return esMovil
}

export default function Landing({ onEmpezarExamen, onVerPlanes, onLogin, onCrearCuenta }) {
  const [scrolled,         setScrolled]         = useState(false)
  const [profSeleccionado, setProfSeleccionado] = useState(null)
  const [menuMovilAbierto, setMenuMovilAbierto] = useState(false)
  const [formTrabajo,      setFormTrabajo]      = useState(null) // 'teacher' | 'developer' | null
  const [formDatos,        setFormDatos]        = useState({ nombre:'', email:'', mensaje:'' })
  const [cvArchivo,        setCvArchivo]        = useState(null)
  const [enviandoForm,     setEnviandoForm]     = useState(false)
  const [formEnviado,      setFormEnviado]      = useState(false)
  const [errorForm,        setErrorForm]        = useState('')
  const esMovil = useEsMovil()

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const letras = [
    { l:'E', c1:'#FFE566', c2:'#FFD700' },
    { l:'s', c1:'#FFE566', c2:'#FFD700' },
    { l:'p', c1:'#FFE566', c2:'#FFD700' },
    { l:'a', c1:'#FFE566', c2:'#FFD700' },
    { l:'ñ', c1:'#7BA7E8', c2:'#4A7FD4' },
    { l:'o', c1:'#7BA7E8', c2:'#4A7FD4' },
    { l:'l', c1:'#7BA7E8', c2:'#4A7FD4' },
    { l:'G', c1:'#FF8A8A', c2:'#E84545' },
    { l:'o', c1:'#FF8A8A', c2:'#E84545' },
  ]

  function LogoSVG({ width = 22, prefix = 'nav' }) {
    return (
      <div style={{ display:'flex', alignItems:'baseline' }}>
        {letras.map((lt, i) => (
          <svg key={i} width={width} height={width * 1.73} viewBox="0 0 36 62"
            style={{ overflow:'visible', flexShrink:0, marginRight: i===6 ? '2px' : '-1px' }}>
            <defs>
              <linearGradient id={prefix + i} x1="0%" y1="110%" x2="0%" y2="-10%">
                <stop offset="0%" stopColor={lt.c2} />
                <stop offset="45%" stopColor={lt.c1} />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0.2" />
              </linearGradient>
              <clipPath id={'c' + prefix + i}>
                <text x="1" y="52" fontSize="52" fontWeight="900" fontFamily="system-ui">{lt.l}</text>
              </clipPath>
            </defs>
            <rect x="-4" y="-4" width="44" height="70"
              fill={'url(#' + prefix + i + ')'}
              clipPath={'url(#c' + prefix + i + ')'} />
          </svg>
        ))}
      </div>
    )
  }

  function scrollTo(id) {
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior:'smooth' })
    setMenuMovilAbierto(false)
  }

  function irAlInicio() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setMenuMovilAbierto(false)
  }

  function abrirFormTrabajo(tipo) {
    setFormTrabajo(tipo)
    setFormDatos({ nombre:'', email:'', mensaje:'' })
    setCvArchivo(null)
    setErrorForm('')
    setFormEnviado(false)
  }

  function seleccionarCv(e) {
    const file = e.target.files[0]
    if (!file) return
    if (file.size > 8 * 1024 * 1024) {
      setErrorForm('El archivo no puede pesar mas de 8MB')
      return
    }
    setCvArchivo(file)
    setErrorForm('')
  }

  async function enviarFormTrabajo() {
    setEnviandoForm(true)
    setErrorForm('')
    try {
      const posicion = formTrabajo === 'teacher' ? 'Teacher' : 'Developer'
      const data = new FormData()
      data.append('nombre', formDatos.nombre)
      data.append('email', formDatos.email)
      data.append('mensaje', formDatos.mensaje)
      data.append('posicion', posicion)
      if (cvArchivo) data.append('cv', cvArchivo)

      await axios.post(API + '/aplicaciones/enviar', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      setFormEnviado(true)
    } catch (err) {
      setErrorForm('No se pudo enviar tu aplicacion. Intenta de nuevo, o escribenos directo a edunovacorporation@gmail.com')
    }
    setEnviandoForm(false)
  }

  const navBtnStyle = {
    background:'none', border:'none', color:'rgba(255,255,255,0.8)', fontFamily:'inherit',
    fontSize:14, cursor:'pointer', padding:'8px 14px', borderRadius:8, textAlign:'left', width:'100%', whiteSpace:'nowrap'
  }

  return (
    <div style={{ fontFamily:'system-ui, sans-serif', overflowX:'hidden' }}>

      {/* NAVBAR */}
      <nav style={{ position:'fixed', top:0, left:0, right:0, zIndex:100,
        background: (scrolled || menuMovilAbierto) ? 'rgba(10,22,40,0.97)' : 'transparent',
        backdropFilter: (scrolled || menuMovilAbierto) ? 'blur(12px)' : 'none',
        borderBottom: (scrolled || menuMovilAbierto) ? '1px solid rgba(255,255,255,0.1)' : 'none',
        transition:'all .3s ease', padding: esMovil ? '0 16px' : '0 40px' }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'flex', alignItems:'center', height:64, gap:16 }}>
          <button onClick={irAlInicio} title="EspañolGo — home"
            style={{ background:'none', border:'none', cursor:'pointer', padding:0, display:'flex', alignItems:'center', gap:8 }}>
            <img src="/espanolgo-logo.png" alt="EspañolGo" style={{ width: esMovil ? 24 : 28, height: esMovil ? 24 : 28, objectFit:'contain' }} />
            {!esMovil && <LogoSVG width={22} prefix="nav" />}
          </button>
          {!esMovil && (
            <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:11, color:'rgba(255,255,255,0.4)', borderLeft:'1px solid rgba(255,255,255,0.2)', paddingLeft:12 }}>
              <img src="/edunova-logo.png" alt="" style={{ width:14, height:14, objectFit:'contain', opacity:.8 }} />
              by EduNova
            </div>
          )}
          <div style={{ flex:1 }} />

          {esMovil ? (
            <button onClick={() => setMenuMovilAbierto(o => !o)}
              style={{ background:'none', border:'none', color:'#fff', fontSize:26, cursor:'pointer', padding:4 }}>
              {menuMovilAbierto ? '✕' : '☰'}
            </button>
          ) : (
            <div style={{ display:'flex', gap:4, alignItems:'center' }}>
              <button onClick={() => scrollTo('teachers')} style={navBtnStyle}>Teachers</button>
              <button onClick={() => scrollTo('work-with-us')} style={navBtnStyle}>Careers</button>
              <button onClick={() => scrollTo('about-us')} style={navBtnStyle}>About Us</button>
              <button onClick={onVerPlanes} style={navBtnStyle}>Pricing</button>
              <button onClick={onLogin}
                style={{ background:'none', border:'1px solid rgba(255,255,255,0.3)', color:'#fff', fontFamily:'inherit', fontSize:14, cursor:'pointer', padding:'8px 20px', borderRadius:8, marginLeft:4, whiteSpace:'nowrap' }}>
                Log in
              </button>
              <button onClick={onCrearCuenta}
                style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', border:'none', color:'#fff', fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer', padding:'9px 20px', borderRadius:8, whiteSpace:'nowrap' }}>
                Get Started
              </button>
            </div>
          )}
        </div>

        {/* Menu desplegable movil */}
        {esMovil && menuMovilAbierto && (
          <div style={{ background:'rgba(10,22,40,0.98)', padding:'8px 16px 20px', display:'flex', flexDirection:'column', gap:4, borderTop:'1px solid rgba(255,255,255,0.08)' }}>
            <button onClick={() => scrollTo('teachers')} style={navBtnStyle}>Teachers</button>
            <button onClick={() => scrollTo('work-with-us')} style={navBtnStyle}>Careers</button>
            <button onClick={() => scrollTo('about-us')} style={navBtnStyle}>About Us</button>
            <button onClick={() => { onVerPlanes(); setMenuMovilAbierto(false) }} style={navBtnStyle}>Pricing</button>
            <button onClick={() => { onLogin(); setMenuMovilAbierto(false) }}
              style={{ background:'none', border:'1px solid rgba(255,255,255,0.3)', color:'#fff', fontFamily:'inherit', fontSize:14, cursor:'pointer', padding:'10px 16px', borderRadius:8, marginTop:6, textAlign:'center' }}>
              Log in
            </button>
            <button onClick={() => { onCrearCuenta(); setMenuMovilAbierto(false) }}
              style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', border:'none', color:'#fff', fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer', padding:'11px 16px', borderRadius:8, textAlign:'center' }}>
              Get Started
            </button>
          </div>
        )}
      </nav>

      {/* HERO */}
      <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0a1628,#0f2347,#1a1248)', position:'relative', display:'flex', alignItems:'center', overflow:'hidden' }}>
        <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', opacity:0.1 }} xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="geo3" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
              <polygon points="30,2 58,16 58,44 30,58 2,44 2,16" fill="none" stroke="#FFD700" strokeWidth="0.8"/>
              <circle cx="30" cy="30" r="2" fill="#FFD700" opacity="0.6"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#geo3)"/>
        </svg>
        <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', opacity:0.15 }} xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="80%" cy="30%" rx="400" ry="400" fill="#7C3AED" opacity="0.15"/>
          <ellipse cx="10%" cy="70%" rx="300" ry="300" fill="#1B3A8C" opacity="0.2"/>
        </svg>

        <div style={{ maxWidth:1320, margin:'0 auto', padding: esMovil ? '110px 20px 60px' : '120px 56px 80px', position:'relative', zIndex:2, width:'100%' }}>
          <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : '1fr 1fr', gap: esMovil ? 40 : 80, alignItems:'center' }}>
            <div style={{ color:'#fff' }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:20 }}>
                <div style={{ background:'rgba(124,58,237,0.3)', border:'1px solid rgba(124,58,237,0.5)', borderRadius:999, padding:'4px 14px 4px 10px', fontSize:12, fontWeight:600, color:'#C4B5FD', display:'flex', alignItems:'center', gap:6 }}>
                  <img src="/edunova-logo.png" alt="" style={{ width:14, height:14, objectFit:'contain' }} />
                  by EduNova Corporation
                </div>
              </div>
              <div style={{ marginBottom:16 }}>
                <LogoSVG width={esMovil ? 36 : 52} prefix="hero" />
              </div>
              <h1 style={{ fontSize: esMovil ? 32 : 48, fontWeight:900, lineHeight:1.15, marginBottom:20 }}>
                Learn Spanish.<br/>
                <span style={{ background:'linear-gradient(135deg,#FFD700,#F59E0B)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
                  Live the culture.
                </span>
              </h1>
              <p style={{ fontSize: esMovil ? 15 : 18, opacity:.8, lineHeight:1.7, marginBottom:32, maxWidth:480 }}>
                Interactive lessons, live classes with Native Spanish Speakers teachers, AI tools and real conversations. From complete beginner to fluent speaker.
              </p>
              <div style={{ display:'flex', gap:12, marginBottom:32, flexWrap:'wrap' }}>
                <button onClick={onEmpezarExamen}
                  style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', border:'none', color:'#fff', fontFamily:'inherit', fontSize: esMovil ? 14 : 16, fontWeight:800, cursor:'pointer', padding: esMovil ? '13px 22px' : '14px 28px', borderRadius:12, width: esMovil ? '100%' : 'auto', whiteSpace:'nowrap' }}>
                  🎯 Take your free Spanish test
                </button>
                <button onClick={onVerPlanes}
                  style={{ background:'rgba(255,255,255,0.1)', border:'1.5px solid rgba(255,255,255,0.3)', color:'#fff', fontFamily:'inherit', fontSize: esMovil ? 14 : 16, fontWeight:600, cursor:'pointer', padding: esMovil ? '13px 22px' : '14px 28px', borderRadius:12, width: esMovil ? '100%' : 'auto', whiteSpace:'nowrap' }}>
                  See our plans →
                </button>
              </div>
              <div style={{ display:'flex', gap:20, flexWrap:'wrap', marginBottom:24 }}>
                {['No credit card required','3-day free trial','Cancel anytime'].map((t,i) => (
                  <div key={i} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, opacity:.75 }}>
                    <span>✅</span><span>{t}</span>
                  </div>
                ))}
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                <div style={{ display:'flex', gap:4 }}>
                  {BANDERAS.slice(0,6).map((b,i) => <Bandera key={i} codigo={b.codigo} pais={b.pais} />)}
                </div>
                <span style={{ fontSize:13, opacity:.6 }}>Students from 10+ countries</span>
              </div>
            </div>

            {/* Mockup */}
            <div style={{ position:'relative' }}>
              <div style={{ background:'rgba(255,255,255,0.05)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:20, padding:24, color:'#fff' }}>
                <div style={{ fontSize:13, opacity:.6, marginBottom:16 }}>🎯 Your Spanish Level Test</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:20 }}>
                  {[
                    { ic:'🎧', label:'Listening', score:'B1', color:'#3B82F6' },
                    { ic:'📖', label:'Reading',   score:'B2', color:'#22C55E' },
                    { ic:'✍️', label:'Writing',   score:'A2', color:'#7C3AED' },
                    { ic:'🎤', label:'Speaking',  score:'A1', color:'#EF4444' },
                  ].map((s,i) => (
                    <div key={i} style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:'14px 16px' }}>
                      <div style={{ fontSize:20, marginBottom:6 }}>{s.ic}</div>
                      <div style={{ fontSize:12, opacity:.7, marginBottom:4 }}>{s.label}</div>
                      <div style={{ fontSize:24, fontWeight:900, color:s.color }}>{s.score}</div>
                    </div>
                  ))}
                </div>
                <div style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', borderRadius:12, padding:16, textAlign:'center' }}>
                  <div style={{ fontSize:13, opacity:.8, marginBottom:4 }}>Your overall level</div>
                  <div style={{ fontSize:36, fontWeight:900 }}>B1</div>
                  <div style={{ fontSize:13, opacity:.7 }}>Intermediate — Challenger 🏆</div>
                </div>
              </div>
              {!esMovil && (
                <>
                  <div style={{ position:'absolute', top:-20, right:-20, background:'#22C55E', borderRadius:12, padding:'10px 16px', color:'#fff', fontSize:13, fontWeight:700, boxShadow:'0 8px 24px rgba(34,197,94,0.4)' }}>
                    🔥 7-day streak!
                  </div>
                  <div style={{ position:'absolute', bottom:-16, left:-16, background:'#fff', borderRadius:12, padding:'10px 16px', fontSize:13, fontWeight:700, color:'#1A1A2E', boxShadow:'0 8px 24px rgba(0,0,0,0.2)' }}>
                    ⚡ +150 XP earned today
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* STATS */}
      <div style={{ background:'#fff', padding: esMovil ? '32px 20px' : '48px 40px', borderBottom:'1px solid #E2E6F0' }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'grid', gridTemplateColumns: esMovil ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap: esMovil ? 20 : 32, textAlign:'center' }}>
          {[
            { num:'500+',  label:'Lessons completed',     ic:'📚' },
            { num:'10+',   label:'Countries represented', ic:'🌎' },
            { num:'2',     label:'Expert teachers',        ic:'👨‍🏫' },
            { num:'Daily', label:'Live classes available', ic:'🎥' },
          ].map((s,i) => (
            <div key={i} style={{ padding: esMovil ? '8px 0' : '20px 0' }}>
              <div style={{ fontSize: esMovil ? 28 : 36, marginBottom:8 }}>{s.ic}</div>
              <div style={{ fontSize: esMovil ? 26 : 36, fontWeight:900, color:'#1B3A8C', marginBottom:4 }}>{s.num}</div>
              <div style={{ fontSize:14, color:'#6B7280' }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* FEATURES */}
      <div style={{ background:'#F8FAFF', padding: esMovil ? '48px 20px' : '80px 40px' }}>
        <div style={{ maxWidth:1200, margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom: esMovil ? 36 : 56 }}>
            <h2 style={{ fontSize: esMovil ? 26 : 36, fontWeight:900, color:'#1A1A2E', marginBottom:12 }}>
              Learn in the way that suits you best
            </h2>
            <p style={{ fontSize: esMovil ? 15 : 18, color:'#6B7280', maxWidth:560, margin:'0 auto' }}>
              Everything you need to speak Spanish with confidence.
            </p>
          </div>
          <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(3,1fr)', gap:24 }}>
            {[
              { ic:'🎥', titulo:'Live Classes',         desc:'Learn with up to 8 students and a native speakers teachers. Multiple sessions daily, every level.', color:'#1B3A8C', bg:'#EEF2FF' },
              { ic:'🎯', titulo:'Placement Test',       desc:'Free 20-question test to evaluate your Listening, Reading, Writing and Speaking. Get your exact level instantly.', color:'#7C3AED', bg:'#F5F3FF' },
              { ic:'📚', titulo:'A1 to C2 Curriculum',  desc:'Complete structured curriculum following the European Framework. Interactive lessons with audio, video and exercises.', color:'#059669', bg:'#F0FDF4' },
              { ic:'🔥', titulo:'Daily Challenges',     desc:'Learn Colombian slangs and real expressions every day. Earn badges and unlock exclusive cultural content.', color:'#EF4444', bg:'#FEF2F2' },
              { ic:'🎮', titulo:'EduNova Games',        desc:'Hangman, trivia, memory games and speed challenges. Learn while having fun and earn XP points.', color:'#F59E0B', bg:'#FFFBEB' },
              { ic:'🏅', titulo:'Badges & Ranking',     desc:'Compete globally. Earn badges for every achievement and climb the worldwide leaderboard.', color:'#6B7280', bg:'#F9FAFB' },
            ].map((f,i) => (
              <div key={i} style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:16, padding:28, transition:'all .2s ease', cursor:'default' }}
                onMouseOver={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='0 12px 32px rgba(0,0,0,0.08)' }}
                onMouseOut={e =>  { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none' }}>
                <div style={{ width:52, height:52, borderRadius:14, background:f.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:26, marginBottom:16 }}>
                  {f.ic}
                </div>
                <h3 style={{ fontSize:18, fontWeight:800, color:'#1A1A2E', marginBottom:8 }}>{f.titulo}</h3>
                <p style={{ fontSize:14, color:'#6B7280', lineHeight:1.7 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TEACHERS */}
      <div id="teachers" style={{ background:'#fff', padding: esMovil ? '48px 20px' : '80px 40px' }}>
        <div style={{ maxWidth:1200, margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom: esMovil ? 36 : 56 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#7C3AED', textTransform:'uppercase', letterSpacing:2, marginBottom:8 }}>
              Meet our team
            </div>
            <h2 style={{ fontSize: esMovil ? 26 : 36, fontWeight:900, color:'#1A1A2E', marginBottom:12 }}>
              Expert Colombian Teachers
            </h2>
            <p style={{ fontSize: esMovil ? 15 : 18, color:'#6B7280', maxWidth:540, margin:'0 auto' }}>
              All our teachers are certified language professionals passionate about sharing Colombian culture and Spanish with the world.
            </p>
          </div>
          <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(2,1fr)', gap:32, maxWidth:900, margin:'0 auto' }}>
            {PROFESORES.map((prof, i) => (
              <div key={i} style={{ border:'1px solid #E2E6F0', borderRadius:20, overflow:'hidden', transition:'all .2s ease', cursor:'pointer' }}
                onMouseOver={e => { e.currentTarget.style.boxShadow='0 12px 32px rgba(0,0,0,0.1)'; e.currentTarget.style.transform='translateY(-4px)' }}
                onMouseOut={e =>  { e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='none' }}
                onClick={() => setProfSeleccionado(prof)}>
                <div style={{ background:'linear-gradient(135deg,' + prof.color + 'dd,' + prof.color + ')', padding:28, color:'#fff', display:'flex', alignItems:'center', gap:20 }}>
                  <div style={{ width:72, height:72, borderRadius:'50%', background:'rgba(255,255,255,0.2)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:36, flexShrink:0 }}>
                    {prof.emoji}
                  </div>
                  <div>
                    <div style={{ fontSize:20, fontWeight:800, marginBottom:4 }}>{prof.nombre}</div>
                    <div style={{ fontSize:13, opacity:.85 }}>{prof.titulo}</div>
                    <div style={{ display:'flex', gap:6, marginTop:8, flexWrap:'wrap' }}>
                      {prof.niveles.map(n => (
                        <span key={n} style={{ background:'rgba(255,255,255,0.25)', borderRadius:999, padding:'2px 10px', fontSize:11, fontWeight:700 }}>{n}</span>
                      ))}
                    </div>
                  </div>
                </div>
                <div style={{ padding:24 }}>
                  <div style={{ background:'#F8FAFF', borderRadius:10, padding:'8px 14px', marginBottom:16, display:'inline-block' }}>
                    <span style={{ fontSize:12, fontWeight:700, color:prof.color }}>📌 {prof.especialidad}</span>
                  </div>
                  <p style={{ fontSize:14, color:'#6B7280', lineHeight:1.7, marginBottom:16 }}>{prof.descripcion}</p>
                  <button onClick={e => { e.stopPropagation(); setProfSeleccionado(prof) }}
                    style={{ background:prof.color, color:'#fff', border:'none', borderRadius:10, padding:'10px 20px', fontFamily:'inherit', fontSize:13, fontWeight:700, cursor:'pointer' }}>
                    View full profile →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA EXAMEN */}
      <div style={{ background:'linear-gradient(135deg,#0a1628,#1a1248)', padding: esMovil ? '48px 20px' : '80px 40px' }}>
        <div style={{ maxWidth:800, margin:'0 auto', textAlign:'center', color:'#fff' }}>
          <div style={{ fontSize: esMovil ? 40 : 56, marginBottom:16 }}>🎯</div>
          <h2 style={{ fontSize: esMovil ? 26 : 40, fontWeight:900, marginBottom:16 }}>What is your Spanish level?</h2>
          <p style={{ fontSize: esMovil ? 15 : 18, opacity:.8, marginBottom:32, lineHeight:1.6 }}>
            Take our free 20-question test and find out your exact level in Listening, Reading, Writing and Speaking. It only takes 10 minutes.
          </p>
          <button onClick={onEmpezarExamen}
            style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', border:'none', color:'#fff', fontFamily:'inherit', fontSize: esMovil ? 15 : 18, fontWeight:800, cursor:'pointer', padding: esMovil ? '14px 24px' : '16px 36px', borderRadius:14, marginBottom:16, width: esMovil ? '100%' : 'auto', whiteSpace:'nowrap' }}>
            🚀 Start your free Spanish test
          </button>
          <div style={{ fontSize:13, opacity:.5 }}>No registration required · Results in 10 minutes</div>
        </div>
      </div>

      {/* PLANS PREVIEW */}
      <div style={{ background:'#fff', padding: esMovil ? '48px 20px' : '80px 40px' }}>
        <div style={{ maxWidth:1200, margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom: esMovil ? 32 : 48 }}>
            <h2 style={{ fontSize: esMovil ? 26 : 36, fontWeight:900, color:'#1A1A2E', marginBottom:12 }}>Simple, transparent pricing</h2>
            <p style={{ fontSize: esMovil ? 15 : 18, color:'#6B7280' }}>Start free. Upgrade when you are ready.</p>
          </div>
          <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(3,1fr)', gap:24, maxWidth:900, margin:'0 auto' }}>
            {[
              { nombre:'3-Day Free Trial',    precio:'FREE',        desc:'Full platform access, 1 live class (group or private), no forums',         color:'#22C55E', emoji:'🎁', popular:false },
              { nombre:'EspañolGo Plus',      precio:'$119.99/mo',  desc:'4 group classes/month, 2 private classes/month, forums included',         color:'#3B82F6', emoji:'📅', popular:false },
              { nombre:'EspañolGo Advanced',  precio:'$719.99/7mo', desc:'8 group classes/month, 4 private classes/month, priority access',         color:'#F59E0B', emoji:'💎', popular:true  },
            ].map((p, i) => (
              <div key={i} style={{ border:'2px solid ' + (p.popular ? p.color : '#E2E6F0'), borderRadius:16, padding:28, position:'relative', background: p.popular ? p.color + '08' : '#fff' }}>
                {p.popular && (
                  <div style={{ position:'absolute', top:-14, left:'50%', transform:'translateX(-50%)', background:p.color, color:'#fff', borderRadius:999, padding:'4px 16px', fontSize:12, fontWeight:800, whiteSpace:'nowrap' }}>
                    ⭐ BEST VALUE
                  </div>
                )}
                <div style={{ fontSize:32, marginBottom:12 }}>{p.emoji}</div>
                <div style={{ fontSize:18, fontWeight:800, color:'#1A1A2E', marginBottom:4 }}>{p.nombre}</div>
                <div style={{ fontSize:28, fontWeight:900, color:p.color, marginBottom:8 }}>{p.precio}</div>
                <div style={{ fontSize:13, color:'#6B7280', lineHeight:1.6, marginBottom:20 }}>{p.desc}</div>
                <button onClick={onVerPlanes}
                  style={{ width:'100%', padding:'11px', background: p.popular ? p.color : 'transparent', color: p.popular ? '#fff' : p.color, border:'2px solid ' + p.color, borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
                  {i === 0 ? 'Start Free' : 'Choose Plan'}
                </button>
              </div>
            ))}
          </div>
          <div style={{ textAlign:'center', marginTop:24 }}>
            <button onClick={onVerPlanes} style={{ background:'none', border:'none', color:'#1B3A8C', fontFamily:'inherit', fontSize:14, cursor:'pointer', textDecoration:'underline' }}>
              See all plans including annual VIP option →
            </button>
          </div>
        </div>
      </div>

      {/* EDUNOVA */}
      <div style={{ background:'#F8FAFF', padding: esMovil ? '40px 20px' : '64px 40px', borderTop:'1px solid #E2E6F0' }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'grid', gridTemplateColumns: esMovil ? '1fr' : '1fr 1fr', gap: esMovil ? 32 : 60, alignItems:'center' }}>
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
              <img src="/edunova-logo.png" alt="EduNova" style={{ width:22, height:22, objectFit:'contain' }} />
              <div style={{ fontSize:12, fontWeight:700, color:'#7C3AED', textTransform:'uppercase', letterSpacing:2 }}>Powered by</div>
            </div>
            <h2 style={{ fontSize: esMovil ? 24 : 32, fontWeight:900, color:'#1A1A2E', marginBottom:16 }}>EduNova Corporation</h2>
            <p style={{ fontSize: esMovil ? 14 : 16, color:'#6B7280', lineHeight:1.8, marginBottom:24 }}>
              EduNova is an education technology company dedicated to creating innovative language learning experiences. EspañolGo is our flagship platform for Spanish education, combining technology, culture and expert teachers from Colombia.
            </p>
            <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
              {['🌎 Global reach','👨‍🏫 Expert teachers','🏆 Certified content','🤝 Student first'].map((item,i) => (
                <div key={i} style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:600, color:'#374151' }}>
                  {item}
                </div>
              ))}
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
            {[
              { ic:'🇨🇴', titulo:'Latin Spanish Colombian Slangs',  desc:'Learn Spanish with native teachers.' },
              { ic:'📜', titulo:'Certified Levels',    desc:'Official certificates following the European Framework A1-C2.' },
              { ic:'🎓', titulo:'Expert Teachers',     desc:'All teachers are certified and trained in our EduNova methodology.' },
              { ic:'💬', titulo:'Real Conversations',  desc:'VideoForums and live sessions with real people, not just robots.' },
            ].map((item,i) => (
              <div key={i} style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, padding: esMovil ? 14 : 20 }}>
                <div style={{ fontSize:28, marginBottom:8 }}>{item.ic}</div>
                <div style={{ fontSize:14, fontWeight:700, color:'#1A1A2E', marginBottom:4 }}>{item.titulo}</div>
                <div style={{ fontSize:12, color:'#6B7280', lineHeight:1.6 }}>{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TRABAJA CON NOSOTROS */}
      <div id="work-with-us" style={{ background:'linear-gradient(135deg,#1B3A8C,#0D1F52)', padding: esMovil ? '40px 20px' : '64px 40px' }}>
        <div style={{ maxWidth:800, margin:'0 auto', textAlign:'center', color:'#fff' }}>
          <div style={{ fontSize: esMovil ? 36 : 48, marginBottom:16 }}>🤝</div>
          <h2 style={{ fontSize: esMovil ? 24 : 32, fontWeight:900, marginBottom:12 }}>Work with us</h2>
          <p style={{ fontSize: esMovil ? 14 : 16, opacity:.8, lineHeight:1.7, marginBottom:40 }}>
            Join the EduNova team and help us build the future of Spanish education.
          </p>

          {!formTrabajo ? (
            <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(2,1fr)', gap:24, maxWidth:600, margin:'0 auto 32px' }}>
              {[
                { id:'teacher',   ic:'👨‍🏫', titulo:'As a Teacher',   desc:'Are you a certified Spanish teacher passionate about language and culture? Teach live classes and VideoForums on EspañolGo.', color:'#7C3AED' },
                { id:'developer', ic:'💻',   titulo:'As a Developer', desc:'Are you a developer interested in EdTech? Join us to build innovative features and help grow the EspañolGo platform.',    color:'#059669' },
              ].map((item) => (
                <div key={item.id}
                  style={{ background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:16, padding:28, textAlign:'left', cursor:'pointer', transition:'all .2s ease' }}
                  onMouseOver={e => { e.currentTarget.style.background='rgba(255,255,255,0.15)'; e.currentTarget.style.transform='translateY(-4px)' }}
                  onMouseOut={e =>  { e.currentTarget.style.background='rgba(255,255,255,0.08)'; e.currentTarget.style.transform='none' }}
                  onClick={() => abrirFormTrabajo(item.id)}>
                  <div style={{ fontSize:40, marginBottom:12 }}>{item.ic}</div>
                  <div style={{ fontSize:18, fontWeight:800, marginBottom:8 }}>{item.titulo}</div>
                  <p style={{ fontSize:13, opacity:.8, lineHeight:1.7, marginBottom:16 }}>{item.desc}</p>
                  <div style={{ fontSize:13, color:item.color, fontWeight:700 }}>Apply now →</div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ background:'#fff', borderRadius:16, padding: esMovil ? 22 : 28, maxWidth:480, margin:'0 auto 32px', textAlign:'left' }}>
              {!formEnviado ? (
                <>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:18 }}>
                    <h3 style={{ fontSize:17, fontWeight:800, color:'#1A1A2E' }}>
                      Apply as {formTrabajo === 'teacher' ? 'Teacher' : 'Developer'}
                    </h3>
                    <button onClick={() => setFormTrabajo(null)} style={{ background:'none', border:'none', fontSize:18, cursor:'pointer', color:'#9CA3AF' }}>✕</button>
                  </div>

                  {errorForm && (
                    <div style={{ background:'#FEF2F2', color:'#991B1B', padding:'8px 12px', borderRadius:8, fontSize:12, marginBottom:14 }}>{errorForm}</div>
                  )}

                  <label style={{ display:'block', fontSize:12, fontWeight:700, color:'#374151', marginBottom:4 }}>Name</label>
                  <input value={formDatos.nombre} onChange={e => setFormDatos(f => ({...f, nombre:e.target.value}))}
                    style={{ width:'100%', padding:'10px 12px', border:'1.5px solid #E2E6F0', borderRadius:8, fontFamily:'inherit', fontSize:14, marginBottom:12, boxSizing:'border-box' }} />
                  <label style={{ display:'block', fontSize:12, fontWeight:700, color:'#374151', marginBottom:4 }}>Email</label>
                  <input type="email" value={formDatos.email} onChange={e => setFormDatos(f => ({...f, email:e.target.value}))}
                    style={{ width:'100%', padding:'10px 12px', border:'1.5px solid #E2E6F0', borderRadius:8, fontFamily:'inherit', fontSize:14, marginBottom:12, boxSizing:'border-box' }} />
                  <label style={{ display:'block', fontSize:12, fontWeight:700, color:'#374151', marginBottom:4 }}>Tell us about you</label>
                  <textarea value={formDatos.mensaje} onChange={e => setFormDatos(f => ({...f, mensaje:e.target.value}))}
                    placeholder="Cuentanos sobre tu experiencia, por que quieres unirte..."
                    style={{ width:'100%', minHeight:90, padding:'10px 12px', border:'1.5px solid #E2E6F0', borderRadius:8, fontFamily:'inherit', fontSize:14, marginBottom:12, resize:'vertical', boxSizing:'border-box' }} />

                  <label style={{ display:'block', fontSize:12, fontWeight:700, color:'#374151', marginBottom:4 }}>Attach your CV (optional)</label>
                  <label style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 12px', border:'1.5px dashed #E2E6F0', borderRadius:8, cursor:'pointer', marginBottom:16, background:'#F8FAFF' }}>
                    <span style={{ fontSize:18 }}>📎</span>
                    <span style={{ fontSize:13, color: cvArchivo ? '#1B3A8C' : '#9CA3AF', fontWeight: cvArchivo ? 700 : 400 }}>
                      {cvArchivo ? cvArchivo.name : 'PDF, DOC or image, max 8MB'}
                    </span>
                    <input type="file" accept=".pdf,.doc,.docx,image/*" onChange={seleccionarCv} style={{ display:'none' }} />
                  </label>

                  <button disabled={!formDatos.nombre || !formDatos.email || enviandoForm} onClick={enviarFormTrabajo}
                    style={{ width:'100%', padding:'12px', background: (!formDatos.nombre || !formDatos.email || enviandoForm) ? '#E2E6F0' : '#1B3A8C', color: (!formDatos.nombre || !formDatos.email || enviandoForm) ? '#9CA3AF' : '#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:700, cursor: (!formDatos.nombre || !formDatos.email || enviandoForm) ? 'not-allowed' : 'pointer' }}>
                    {enviandoForm ? 'Sending...' : 'Send application'}
                  </button>
                </>
              ) : (
                <div style={{ textAlign:'center', padding:'10px 0' }}>
                  <div style={{ fontSize:40, marginBottom:10 }}>✅</div>
                  <p style={{ fontSize:15, fontWeight:700, color:'#166534', marginBottom:6 }}>Application sent!</p>
                  <p style={{ fontSize:13, color:'#6B7280', marginBottom:16 }}>Thank you for applying. Our team will review your application and reach out soon.</p>
                  <button onClick={() => setFormTrabajo(null)} style={{ display:'block', margin:'0 auto', background:'#F4F6FA', border:'none', borderRadius:8, padding:'8px 20px', fontSize:13, cursor:'pointer' }}>Close</button>
                </div>
              )}
            </div>
          )}

          <div style={{ background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:14, padding:'16px 24px', display:'inline-block', marginBottom:24 }}>
            <div style={{ fontSize:13, opacity:.7, marginBottom:4 }}>Or write to us directly</div>
            <a href="mailto:edunovacorporation@gmail.com" style={{ fontSize: esMovil ? 15 : 18, fontWeight:800, color:'#FFD700', textDecoration:'none', wordBreak:'break-all' }}>
              edunovacorporation@gmail.com
            </a>
          </div>
          <div style={{ display:'flex', gap:16, justifyContent:'center', flexWrap:'wrap' }}>
            {['✅ Flexible schedule','✅ Remote work','✅ Competitive pay','✅ Growing platform'].map((item,i) => (
              <div key={i} style={{ fontSize:13, opacity:.8 }}>{item}</div>
            ))}
          </div>
        </div>
      </div>

      {/* ABOUT US */}
      <div id="about-us" style={{ background:'#fff', padding: esMovil ? '48px 20px' : '80px 40px', borderTop:'1px solid #E2E6F0' }}>
        <div style={{ maxWidth:900, margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom: esMovil ? 36 : 52 }}>
            <div style={{ fontSize: esMovil ? 36 : 48, marginBottom:16 }}>🏢</div>
            <h2 style={{ fontSize: esMovil ? 24 : 32, fontWeight:900, color:'#1A1A2E', marginBottom:16 }}>About EduNova</h2>
            <p style={{ fontSize: esMovil ? 15 : 17, color:'#6B7280', lineHeight:1.8, maxWidth:640, margin:'0 auto' }}>
              EduNova was built from real classroom experience — not just theory. Our founders have taught in real classrooms and lived the day to day realities students and teachers face, and we built EspañolGo from that experience.
            </p>
          </div>

          <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(2,1fr)', gap:20, marginBottom: esMovil ? 32 : 44 }}>
            <div style={{ background:'#F8FAFF', border:'1px solid #E2E6F0', borderRadius:16, padding:24 }}>
              <div style={{ fontSize:28, marginBottom:10 }}>🎓</div>
              <h3 style={{ fontSize:16, fontWeight:800, color:'#1A1A2E', marginBottom:8 }}>Trained, real teachers</h3>
              <p style={{ fontSize:14, color:'#6B7280', lineHeight:1.7 }}>
                Every class is led by a trained, certified teacher — not a script. We believe language is best learned from people who have dedicated their careers to teaching it well.
              </p>
            </div>
            <div style={{ background:'#F8FAFF', border:'1px solid #E2E6F0', borderRadius:16, padding:24 }}>
              <div style={{ fontSize:28, marginBottom:10 }}>🌎</div>
              <h3 style={{ fontSize:16, fontWeight:800, color:'#1A1A2E', marginBottom:8 }}>Our mission</h3>
              <p style={{ fontSize:14, color:'#6B7280', lineHeight:1.7 }}>
                We want to reach millions of students around the world and build a lasting educational community — a place where people don't just learn Spanish, they connect with it.
              </p>
            </div>
          </div>

          <div style={{ background:'linear-gradient(135deg,#1B3A8C,#0D1F52)', borderRadius:16, padding: esMovil ? 24 : 32, color:'#fff', marginBottom:24, textAlign:'center' }}>
            <div style={{ fontSize:28, marginBottom:10 }}>🤝</div>
            <h3 style={{ fontSize:18, fontWeight:800, marginBottom:10 }}>Looking for teachers and investors in Colombian education</h3>
            <p style={{ fontSize:14, opacity:.85, lineHeight:1.8, maxWidth:600, margin:'0 auto' }}>
              We are actively looking to connect with people who want to teach, and with people who want to invest in education in Colombia. EduNova is not a foundation, but we operate — and always will — without a profit-first mindset. Growth for us means more students learning, not just more revenue.
            </p>
          </div>

          <p style={{ fontSize:14, color:'#6B7280', textAlign:'center', wordBreak:'break-all' }}>
            For inquiries, partnerships or investment, contact us at{' '}
            <a href="mailto:edunovacorporation@gmail.com" style={{ color:'#1B3A8C', fontWeight:700 }}>
              edunovacorporation@gmail.com
            </a>
          </p>
        </div>
      </div>

      {/* FOOTER */}
      <div style={{ background:'#0a1628', padding: esMovil ? '28px 20px' : '40px', color:'rgba(255,255,255,0.6)' }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'flex', alignItems: esMovil ? 'flex-start' : 'center', justifyContent:'space-between', flexWrap:'wrap', gap:16, flexDirection: esMovil ? 'column' : 'row' }}>
          <div>
            <button onClick={irAlInicio} style={{ background:'none', border:'none', cursor:'pointer', padding:0, display:'flex', alignItems:'center', gap:8, marginBottom:6 }}>
              <img src="/edunova-logo.png" alt="EduNova" style={{ width:20, height:20, objectFit:'contain' }} />
              <div style={{ fontSize:16, fontWeight:900, color:'#fff' }}>
                <span style={{ color:'#FFD700' }}>Esp</span>
                <span style={{ color:'#7BA7E8' }}>añ</span>
                <span style={{ color:'#FF8A8A' }}>olGo</span>
                <span style={{ color:'rgba(255,255,255,0.4)', fontSize:12, fontWeight:400, marginLeft:8 }}>by EduNova Corporation</span>
              </div>
            </button>
            <div style={{ fontSize:12 }}>© 2026 EduNova Corporation. All rights reserved.</div>
            <div style={{ fontSize:12, marginTop:6 }}>
              📧 <a href="mailto:edunovacorporation@gmail.com" style={{ color:'rgba(255,255,255,0.6)' }}>edunovacorporation@gmail.com</a>
            </div>
          </div>
          <div style={{ display:'flex', gap:20, fontSize:13, flexWrap:'wrap' }}>
            <button onClick={onEmpezarExamen}           style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>Take the test</button>
            <button onClick={onVerPlanes}               style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>Pricing</button>
            <button onClick={() => scrollTo('teachers')}style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>Teachers</button>
            <button onClick={() => scrollTo('work-with-us')} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>Careers</button>
            <button onClick={() => scrollTo('about-us')}style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>About Us</button>
            <button onClick={onLogin}                   style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>Log in</button>
          </div>
        </div>
      </div>

      {/* MODAL PROFESOR */}
      {profSeleccionado && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}
          onClick={() => setProfSeleccionado(null)}>
          <div style={{ background:'#fff', borderRadius:20, maxWidth:540, width:'100%', overflow:'hidden', maxHeight:'90vh', overflowY:'auto' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ background:'linear-gradient(135deg,' + profSeleccionado.color + 'dd,' + profSeleccionado.color + ')', padding: esMovil ? 22 : 32, color:'#fff', display:'flex', alignItems:'center', gap:20 }}>
              <div style={{ width:88, height:88, borderRadius:'50%', background:'rgba(255,255,255,0.2)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:44, flexShrink:0 }}>
                {profSeleccionado.emoji}
              </div>
              <div>
                <div style={{ fontSize:22, fontWeight:900, marginBottom:4 }}>{profSeleccionado.nombre}</div>
                <div style={{ fontSize:14, opacity:.85, marginBottom:10 }}>{profSeleccionado.titulo}</div>
                <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                  {profSeleccionado.niveles.map(n => (
                    <span key={n} style={{ background:'rgba(255,255,255,0.25)', borderRadius:999, padding:'3px 12px', fontSize:12, fontWeight:700 }}>{n}</span>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ padding: esMovil ? 20 : 28 }}>
              <div style={{ background:'#F8FAFF', borderRadius:10, padding:'10px 16px', marginBottom:16, display:'inline-block' }}>
                <span style={{ fontSize:13, fontWeight:700, color:profSeleccionado.color }}>📌 {profSeleccionado.especialidad}</span>
              </div>
              <p style={{ fontSize:15, color:'#374151', lineHeight:1.8, marginBottom:24 }}>{profSeleccionado.descripcion}</p>
              <div style={{ display:'flex', gap:10, flexDirection: esMovil ? 'column' : 'row' }}>
                <button onClick={onEmpezarExamen}
                  style={{ flex:1, padding:'12px', background:profSeleccionado.color, color:'#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
                  Start learning with {profSeleccionado.nombre.split(' ')[0]}
                </button>
                <button onClick={() => setProfSeleccionado(null)}
                  style={{ padding:'12px 20px', background:'#F4F6FA', color:'#6B7280', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:14, cursor:'pointer' }}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
